const ENTRY_TRAFFIC_KEY = 'entryTraffic';
const ENTRY_TRAFFIC_WINDOW_MS = 30 * 60 * 1000;

export interface EntrySignals {
    referrer: string | null;
    utm_medium: string | null;
}

const EMPTY_ENTRY_SIGNALS: EntrySignals = { referrer: null, utm_medium: null };

/**
 * Session-entry signals used by the backend to classify traffic_source.
 * Written by the capture block in web/templates/partials/critical_js.html;
 * nulls when missing, expired or storage is blocked.
 */
export const getEntrySignals = (): EntrySignals => {
    try {
        const raw = localStorage.getItem(ENTRY_TRAFFIC_KEY);
        if (!raw) return EMPTY_ENTRY_SIGNALS;
        const data = JSON.parse(raw);
        if (!data || typeof data.timestamp !== 'number' || Date.now() - data.timestamp >= ENTRY_TRAFFIC_WINDOW_MS) {
            return EMPTY_ENTRY_SIGNALS;
        }
        return {
            referrer: typeof data.referrer === 'string' ? data.referrer : null,
            utm_medium: typeof data.utm_medium === 'string' ? data.utm_medium : null,
        };
    } catch (_) {
        return EMPTY_ENTRY_SIGNALS;
    }
};

export interface RecommendationClickPayload {
    video_id: number;
    page_number: number;
    item_position: number;
    recommendation_id?: string;
    keyword?: string;
    country_code?: string;
    orientation?: string;
    logged_in?: boolean;
    entry_referrer?: string | null;
    entry_utm_medium?: string | null;
}

export const sendRecommendationClick = (payload: RecommendationClickPayload) => {
    const entrySignals = getEntrySignals();
    fetch('/api/recommendations/click', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ...payload,
            entry_referrer: entrySignals.referrer,
            entry_utm_medium: entrySignals.utm_medium,
        }),
    });
};

export type RecommendationScenario = 'home_page';

export interface SendRecommendationImpressionPayload {
    recommendation_id: string;
    scenario: RecommendationScenario;
}

export const trackRecommendationImpression = (payload: SendRecommendationImpressionPayload) => {
    fetch('/api/recommendations/track-impression', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
    });
};
